import {NgModule} from '@angular/core';
import {CreditNoteRoutingModule} from '@app/modules/credit-note/credit-note-routing.module';

@NgModule({
  imports: [CreditNoteRoutingModule]
})
export class CreditNoteModule {
}
